import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"

import tracking from "@irati-tracking/admin"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"

import MostPopularPerks from "../../../components/Reporting/Perks/MostPopularPerks"
import PerksByTeam from "../../../components/Reporting/Perks/PerksByTeam"
import Interests from "../Interests"

interface Props extends InjectIntl {}

class Groups extends Component<Props> {

  componentDidMount = () => {
    tracking.analyticsTeams()
  }

  render() {
    const {formatMessage} = this.props

    return (
      <Tabs
        id="adminSection_reportingTab"
        addMarginTop
        mountOnEnter
        unmountOnExit
        tabs={[
          {
            title: formatMessage({id: "admin.reporting.tabs.perksSummary"}),
            key: "perksSummary ",
            component: (
              <>
                <MostPopularPerks />
                <Interests />
              </>
            )
          },
          {
            title: formatMessage({id: "admin.reporting.tabs.teamAndCountry"}),
            key: "teamAndCountry ",
            component: (
              <>
                <H2 marginBottom={4} marginTop={5}>
                  <FormattedMessage id="admin.analytics.teams.title" />
                </H2>
                <Row>
                  <Col xs={12} lg={6}>
                    <PerksByTeam
                      title="admin.reporting.perksByTeam.countries.title"
                      isRegion />
                  </Col>
                  <Col xs={12} lg={6}>
                    <PerksByTeam
                      title="admin.reporting.perksByTeam.teams.title" />
                  </Col>
                </Row>
                </>
            )
          }
        ]} />
    )
  }
}

export default injectIntl(Groups)
